﻿import { sendDataLayer } from "../../components/ecommerce/ecommerce";
import { getTranslations } from "../../translations";
import { Popup, PopupButton, PopupPosition } from "../../utilities/popup";
import { showConfirmPopup } from "../../utilities/popup.confirm";
import { progressSpinner } from "../../utilities/progressSpinner";

document.addEventListener("DOMContentLoaded", () =>
{
    initFavoritesPage();
});

export const initFavoritesPage = () =>
{
    var errorHtml = $(".error").html();
    var errors = [];

    if (errorHtml && errorHtml.length > 0)
    {
        if (errorHtml.indexOf("<br> ") > 0)
            errors = errorHtml.split("<br> ");
        else if (errorHtml.indexOf("<br /> ") > 0)
            errors = errorHtml.split("<br /> ");
        else if (errorHtml.indexOf("<br />") > 0)
            errors = errorHtml.split("<br />");
        else if (errorHtml.indexOf("<br>") > 0)
            errors = errorHtml.split("<br>");
    }

    $(errors).each(function ()
    {
        if (this != null && this != "")
        {
            sendDataLayer({
                'event': 'Error',
                'category': 'Error',
                'action': document.location.pathname,
                'label': this.toString()
            });
        }
    });
};

export const CheckSendFavorites = (src) =>
{
    if ($(src).val() != 0)
        $(src).closest("form").trigger('submit');
};

export const Facebook = (hashlist) =>
{
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + hashlist.getAttribute("data-url") + "/favoritelist/hash/" + hashlist.getAttribute("data-hash"), '_blank');
    return false;
}

export const showConfirmDeleteFavoriteList = (listID: number) =>
{
    const deletePopup = showConfirmPopup({
        id: "deletefav",
        title: "",
        content: getTranslations().txtRemoveList,
        onConfirm: () =>
        {
            deleteList(listID);
            deletePopup.hide();            
        }
    });
};

export const deleteList = (listID: number) =>
{
    $.ajax({
        url: "/Services/modules/Webshop.asmx/RemoveListFromFavorites?listID=" + listID,
        dataType: "json",
        complete: function (data) 
        {
            if (typeof data !== typeof (undefined) &&
                data != null &&
                typeof data.responseJSON !== typeof (undefined) &&
                data.responseJSON != null && data.responseJSON.Success)
            {
                // Remove list in html
                $(".c-favorite-item[data-list-id=" + listID + "]").remove();

                // Remove favourite list option from articles in other lists.
                $("option[value=" + listID + "]").remove();

                // Update or set header icon counter
                if ($(".js-header-fav-counter").length > 0)
                {
                    if (data.responseJSON.FavoriteCount == 0)
                        $(".js-header-fav-counter").html('');
                    else
                        $(".js-header-fav-counter").html(data.responseJSON.FavoriteCount);
                }
            }
        },
        error: function (xhr)
        {
            console.log('Request Status: ' + xhr.status + ' Status Text: ' + xhr.statusText + ' ' + xhr.responseText);
        }
    });
}

export const showPopup = () =>
{
    showAddFavoritePopup();
}

export const showAddFavoritePopup = () =>
{
    const buttons = [];
    const content = $(".js-favorite-add-popup").html();

    const saveButton = new PopupButton();
    saveButton.label = getTranslations().txtSave;
    saveButton.className = "btn btn-green";

    saveButton.onClick = (e) =>
    {
        e.preventDefault();
        e.stopPropagation();
        
        $("#modal-add-fav").find(".js-btn-save").trigger("click");
    };
    buttons.push(saveButton);

    const popup = new Popup({
        id: "add-fav",
        content: content,
        title: $(content).find(".title").text(),
        closeButton: true,
        mobilePosition: PopupPosition.Center,
        desktopPosition: PopupPosition.Popup,
        buttons: buttons
    });

    popup.show();
}

(window as any).showPopup = showPopup;
(window as any).showAddFavoritePopup = showAddFavoritePopup;
(window as any).showConfirmDeleteFavoriteList = showConfirmDeleteFavoriteList;
(window as any).deleteList = deleteList;
(window as any).Facebook = Facebook;
(window as any).CheckSendFavorites = CheckSendFavorites;